import { Box, CircularProgress, Dialog, DialogContent } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import quickbookApi from '~/apis/quickbook';
import { cast, handleApiError } from '~/utils/helper';
import { IBodyAuthenticate } from '~/utils/interface/quickbook';
import classNames from 'classnames/bind';
import styles from './QuickbookAuthCallback.module.scss';
import { useTranslation } from 'react-i18next';
import { STORAGE_QUICKBOOK_PREVOUS_URL } from '~/utils/constants/quickbook';
import { CheckMarkCircleIcon } from '~/assets/icons';
import useQuickbook from '~/hooks/useQuickbook';

const cx = classNames.bind(styles);

const QuickbookAuthCallback = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const [searchParams] = useSearchParams();
  const { t } = useTranslation(['admin/quickbook']);
  const navigate = useNavigate();
  const { fetchQuickbook } = useQuickbook();
  const isSubmit = useRef(false); // Ignore call 2 times occurs error in dev mode
  //#endregion Declare Hook

  //#region Selector

  //#endregion Selector

  //#region Declare State
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (authenticate && searchParams) {
      if (isSubmit.current) return;
      isSubmit.current = true;
      const code = cast(searchParams.get('code'));
      const state = cast(searchParams.get('state'));
      const realmId = cast(searchParams.get('realmId'));
      if (code) {
        authenticate({
          code,
          state,
          realmId,
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion Implement Hook

  //#region Handle Function
  const authenticate = async (data: IBodyAuthenticate) => {
    try {
      await quickbookApi.authenticate(data);
      fetchQuickbook();
      setIsAuthenticated(true);
    } catch (e: unknown) {
      handleApiError(e);
    } finally {
      const previousUrl = cast(localStorage.getItem(STORAGE_QUICKBOOK_PREVOUS_URL));
      localStorage.removeItem(STORAGE_QUICKBOOK_PREVOUS_URL);
      isSubmit.current = false;
      if (previousUrl) {
        setTimeout(() => {
          navigate(previousUrl);
        }, 1500);
      }
    }
  };
  //#endregion Handle Function

  return (
    <Dialog open={true} maxWidth='sm'>
      <DialogContent className='!p-[30px] flex items-center flex-col'>
        <Box>
          <Box className={'w-[200px] h-[150px] flex items-center justify-center'}>
            {isAuthenticated ? (
              <CheckMarkCircleIcon className={cx('connect-success-icon')} />
            ) : (
              <CircularProgress className={cx('circular-progress')} size={100} />
            )}
          </Box>
        </Box>
        <Box className='text-[#42485B] text-[16px]/[24px]'>
          {isAuthenticated ? t('authCallback.connectSuccess') : t('authCallback.authenticating')}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default QuickbookAuthCallback;
